import {
  LayoutGrid,
  Video,
  Users,
  FileText,
  ClipboardCheck,
  Building2,
  BarChart3,
  Swords,
  ShieldCheck,
  type LucideIcon,
} from 'lucide-react';

export type BatchTabId =
  | 'overview'
  | 'sessions'
  | 'students'
  | 'assignments'
  | 'assessments'
  | 'hackathons'
  | 'company-readiness'
  | 'integrity'
  | 'reports';

export interface BatchTab {
  id: BatchTabId;
  label: string;
  icon: LucideIcon;
  /** whether the tab is backed by real data (wired) or a coming-soon shell */
  wired: boolean;
  /** coming-soon copy for shell tabs */
  soon?: string;
}

export const BATCH_TABS: BatchTab[] = [
  { id: 'overview', label: 'Overview', icon: LayoutGrid, wired: true },
  { id: 'sessions', label: 'Sessions', icon: Video, wired: true },
  { id: 'students', label: 'Students', icon: Users, wired: true },
  { id: 'assignments', label: 'Assignments', icon: FileText, wired: true },
  { id: 'assessments', label: 'Assessments', icon: ClipboardCheck, wired: true },
  { id: 'hackathons', label: 'Hackathons', icon: Swords, wired: true },
  { id: 'company-readiness', label: 'Company Readiness', icon: Building2, wired: true },
  // Placed after the placement tabs and before Reports: it is the evidence
  // behind the readiness numbers above it, not a discipline screen of its own.
  { id: 'integrity', label: 'Integrity', icon: ShieldCheck, wired: true },
  { id: 'reports', label: 'Reports', icon: BarChart3, wired: true },
];
